(function() {
    'use strict';

    angular
        .module('liverunApp')
        .controller('RunnerDeleteController',RunnerDeleteController);

    RunnerDeleteController.$inject = ['$uibModalInstance', 'entity', 'Runner'];

    function RunnerDeleteController($uibModalInstance, entity, Runner) {
        var vm = this;

        vm.runner = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Runner.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
